var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightPromptify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1189,
    height: 1189,
    viewBox: "0 0 1189 1189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_3201_742)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 594.5,
    cy: 594.5,
    r: 218.5,
    fill: "#990CE8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3201_742)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 594.5,
    cy: 594.5,
    r: 142.5,
    fill: "#D500FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3201_742",
    x: 0.945221,
    y: 0.945221,
    width: 1187.11,
    height: 1187.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187.527,
    result: "effect1_foregroundBlur_3201_742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3201_742",
    x: 344.841,
    y: 344.841,
    width: 499.317,
    height: 499.317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 53.5793,
    result: "effect1_foregroundBlur_3201_742"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPromptify);
export default __webpack_public_path__ + "static/media/light-promptify.ac31828c72fe188a413299c5f6ae3b40.svg";
export { ForwardRef as ReactComponent };